// extracted by mini-css-extract-plugin
export var actions = "_3v-0";
export var actionsContainer = "_3v-7";
export var border = "_3v-1";
export var childFullHeight = "_3v-f";
export var collapse = "_3v-2";
export var content = "_3v-a";
export var contentChild = "_3v-e";
export var fullscreen = "_3v-c";
export var hasLeftRadius = "_3v-k";
export var headerContainer = "_3v-3";
export var headerRow = "_3v-5";
export var hidePadding = "_3v-b";
export var navCollapsedGap = "_3v-l";
export var noScrollX = "_3v-m";
export var noScrollY = "_3v-n";
export var noTopPadding = "_3v-i";
export var optOutTopPadding = "_3v-d";
export var pageMain = "_3v-j";
export var pageOuter = "_3v-g";
export var pagePadding = "_3v-8";
export var pageScroll = "_3v-9";
export var profile = "_3v-o";
export var profileContainer = "_3v-p";
export var profileImage = "_3v-q";
export var profileMain = "_3v-r";
export var profileSubtitle = "_3v-t";
export var profileTitle = "_3v-s";
export var showLeftPadding = "_3v-h";
export var tabsPortalSlot = "_3v-6";
export var tabsWrapper = "_3v-4";
export var title = "_3v-u";